import React, { useEffect, useState } from 'react';

const QuadratureElementRapporti = ({labelA, labelB, totaleOreQuadrature}) => {

    const [quadraturaOre, setQuadraturaOre] = useState({
        gennaio: "", febbraio: "", marzo: "", 
        aprile: "", maggio: "", giugno: "", 
        luglio: "", agosto: "", settembre: "", 
        ottobre: "", novembre: "", dicembre: "", 
        totale: ""
    });

    useEffect(() => {
        // ✅ CHECK: Se totaleOreQuadrature è vuoto/undefined, usa valori sicuri
        if (!totaleOreQuadrature || typeof totaleOreQuadrature !== 'object') {
            setQuadraturaOre({
                gennaio: "", febbraio: "", marzo: "", 
                aprile: "", maggio: "", giugno: "", 
                luglio: "", agosto: "", settembre: "", 
                ottobre: "", novembre: "", dicembre: "", 
                totale: ""
            });
            return;
        }

        // ✅ Usa i valori dal backend (che sono già rapporti, NON minuti)
        setQuadraturaOre({
            gennaio: safeValue(totaleOreQuadrature.gennaio),
            febbraio: safeValue(totaleOreQuadrature.febbraio),
            marzo: safeValue(totaleOreQuadrature.marzo),
            aprile: safeValue(totaleOreQuadrature.aprile),
            maggio: safeValue(totaleOreQuadrature.maggio),
            giugno: safeValue(totaleOreQuadrature.giugno),
            luglio: safeValue(totaleOreQuadrature.luglio),
            agosto: safeValue(totaleOreQuadrature.agosto),
            settembre: safeValue(totaleOreQuadrature.settembre),
            ottobre: safeValue(totaleOreQuadrature.ottobre),
            novembre: safeValue(totaleOreQuadrature.novembre),
            dicembre: safeValue(totaleOreQuadrature.dicembre),
            totale: safeValue(totaleOreQuadrature.totale)
        });
    }, [totaleOreQuadrature]);

    // ✅ Funzione per gestire valori sicuri (i rapporti sono già formattati)
    const safeValue = (value) => {
        if (value === undefined || value === null || value === "") {
            return "";
        }
        // Se è un numero, formattalo con 2 decimali (es: rapporti come 0.85)
        if (typeof value === 'number') {
            return value.toFixed(2);
        }
        // Se è già una stringa, ritornala così com'è
        return String(value);
    };

    const onChangeData = (field, value) => {
        setQuadraturaOre({ ...quadraturaOre, [field]: value });      
    }
    
    return (
        <div key={"quadraturaOreTotaleRapporto"} className={`w-layout-grid div_column_quadrature_ore testi-grassetto`}>
            <div className="div_item_column div_item_column_quadratura_ore">
                <div className="item_table_quadratura">{labelA}</div>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <div className="item_table_quadratura">{labelB}</div>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.gennaio" value={quadraturaOre.gennaio || ""} onChange={(e) => {onChangeData('gennaio', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.febbraio" value={quadraturaOre.febbraio || ""} onChange={(e) => {onChangeData('febbraio', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.marzo" value={quadraturaOre.marzo || ""} onChange={(e) => {onChangeData('marzo', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.aprile" value={quadraturaOre.aprile || ""} onChange={(e) => {onChangeData('aprile', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.maggio" value={quadraturaOre.maggio || ""} onChange={(e) => {onChangeData('maggio', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.giugno" value={quadraturaOre.giugno || ""} onChange={(e) => {onChangeData('giugno', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.luglio" value={quadraturaOre.luglio || ""} onChange={(e) => {onChangeData('luglio', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.agosto" value={quadraturaOre.agosto || ""} onChange={(e) => {onChangeData('agosto', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.settembre" value={quadraturaOre.settembre || ""} onChange={(e) => {onChangeData('settembre', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.ottobre" value={quadraturaOre.ottobre || ""} onChange={(e) => {onChangeData('ottobre', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.novembre" value={quadraturaOre.novembre || ""} onChange={(e) => {onChangeData('novembre', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.dicembre" value={quadraturaOre.dicembre || ""} onChange={(e) => {onChangeData('dicembre', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
            <div className="div_item_column div_item_column_quadratura_ore">
                <input type="text" name="quadraturaOre.totale" value={quadraturaOre.totale || ""} onChange={(e) => {onChangeData('totale', e.target.value)}} className="input w-input edit_quadratura item_table_quadratura"/>
            </div>
        </div>
    )
}

export default QuadratureElementRapporti;
